import Lawyer from './lawyer'
export default [
  {
    path: '/lawyer',
    name: 'home-lawyer',
    component: Lawyer
  }
]



// WEBPACK FOOTER //
// ./src/components/lawyer/lawyer-router.js